import axios from "axios";
import { getCurrentVersion } from "./business";
import {
  compareVersion,
  dispatchSDK,
  dispatchToast,
  isIOSDevice,
  removeUrlParameter,
} from "./extend";

const service = axios.create({
  baseURL: process.env.REACT_APP_BASEURL,
});

service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const extendParams = config.params || {};
    if (token) {
      extendParams.token = token;
    }
    config.params = extendParams;
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const { data, config } = response;
    const { code, msg } = data;
    const { url } = config;
    // 当token过期，且不是任务接口，提示登录凭证已过期
    if (code === 401 && url !== "/my/task") {
      // 当为低版本iOS时，不提示登录凭证已过期，不登出，跳到反馈页
      const sdkVersion = getCurrentVersion();
      const isFixedVersion = compareVersion(sdkVersion, "3.6.1") >= 0;
      if (isIOSDevice() && !isFixedVersion) {
        if (window.location.pathname !== "/v19/services") {
          const nextSearch = removeUrlParameter(
            window.location.search,
            "token"
          );
          localStorage.removeItem("token");
          window.location.href = window.location.origin + "/v19/services" + nextSearch;
        }
        return;
      }
      dispatchToast.warning("登录凭证已过期");
      dispatchSDK("loginFailure");
      return Promise.reject();
    }
    if (code !== 200 && code !== 201 && url !== "/my/task") {
      setTimeout(() => {
        dispatchToast.warning(msg || "请求出错");
      }, 0);
      return Promise.reject();
    }
    if (code === 201) {
      setTimeout(() => {
        dispatchToast.show(msg || "成功");
      }, 0);
    }
    return data;
  },
  (error) => {
    setTimeout(() => {
      const sdkVersion = getCurrentVersion();
      const isFixedVersion = compareVersion(sdkVersion, "3.6.1") >= 0;
      if (isIOSDevice() && !isFixedVersion) {
        return;
      }
      dispatchToast.warning("网络出错");
    }, 0);
    return Promise.reject(error);
  }
);

export default service;
